// src/services/FunctionalDepartmentService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getFunctionalDepartments = async () => {
  return await axios.get(`${API_URL}/functional_departments/details`);
};

const getFunctionalDepartment = async (id) => {
  return await axios.get(`${API_URL}/functional_departments/${id}`);
};

const createFunctionalDepartment = async (userData) => {
  return await axios.post(`${API_URL}/functional_departments/`, userData);
};

const updateFunctionalDepartment = async (id, userData) => {
  return await axios.put(`${API_URL}/functional_departments/${id}`, userData);
};

const deleteFunctionalDepartment = async (id) => {
  return await axios.delete(`${API_URL}/functional_departments/${id}`);
};

const getReportingHeads = async () => {
  return await axios.get(`${API_URL}/volunteers/reporting_heads`);
};

const getVendorByReportingHead = async (id) => {
  return await axios.get(`${API_URL}/volunteers/vendor_by_rep_head/${id}`);
};

const getDepartmentByVendorId = async (id) => {
  return await axios.get(`${API_URL}/volunteers/dept_by_vendor/${id}`);
};

export default {
  getFunctionalDepartments,
  getFunctionalDepartment,
  createFunctionalDepartment,
  updateFunctionalDepartment,
  deleteFunctionalDepartment,
  getReportingHeads,
  getVendorByReportingHead,
  getDepartmentByVendorId,
};
